export const NEEDS_RE_AUTHENTICATION = 'NEEDS_RE_AUTHENTICATION'

export const VERIFY_REGISTRATION_TOKEN = 'VERIFY_REGISTRATION_TOKEN'
export const VERIFY_REGISTRATION_TOKEN_INDICATOR = 'VERIFY_REGISTRATION_TOKEN_INDICATOR'

export const VERIFY_RESET_PASSWORD_TOKEN = 'VERIFY_RESET_PASSWORD_TOKEN'
export const VERIFY_RESET_PASSWORD_TOKEN_INDICATOR = 'VERIFY_RESET_PASSWORD_TOKEN_INDICATOR'